import React from 'react';
import ptBR from 'antd/lib/locale/pt_BR';
import { ConfigProvider } from 'antd';
import { RouterProvider } from 'react-router-dom';
import { router } from './router/routes';
import toast, { Toaster, ToastBar } from 'react-hot-toast';

function App(): JSX.Element {
  return (
    <div className="App">
      <ConfigProvider locale={ptBR}>
        <RouterProvider router={router} />
        <Toaster>
          {(t) => (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <>
                  {icon}
                  {message}
                  {t.type !== 'loading' && (
                    <button onClick={() => toast.dismiss(t.id)}>X</button>
                  )}
                </>
              )}
            </ToastBar>
          )}
        </Toaster>
      </ConfigProvider>
    </div>
  );
}

export default App;
